module.exports = __webpack_public_path__ + "static/media/1014034.819ae88f.jpg";